import {
  parseDoorData,
  parseTemperature,
  useTimeZone,
  useTranslation
} from '@fareye/common'
import { Flex } from '@fareye/ui'
import {
  cloneDeep,
  hhmmADoMMMYYYY,
  isNullUndefinedAndEmpty,
  toTileCase
} from '@fareye/utils'
import React from 'react'
import { Icon, latLng, Marker, Popup, useMap } from '@fareye/ui'
import { displayTime } from '../../utility/function'
export function HistoryMarker({
  iconUrl,
  iconSize,
  history,
  selected,
  type = ''
}: any) {
  const {
    landmark,
    speed,
    istTimestamp,
    latitude,
    longitude,
    gpsTimestamp,
    extraData,
    state: historyState
  } = history || {}
  let speedStr = `${isNullUndefinedAndEmpty(speed) ? '-' : speed + ' Km/hr'}`
  let displayExtraInfo: any = {}
  if (extraData) {
    displayExtraInfo = cloneDeep(extraData) || {}
    if (displayExtraInfo?.temperature) {
      const temperatureUnit = displayExtraInfo?.temperature_unit ?? displayExtraInfo?.temperatureUnit ?? '°C'
      displayExtraInfo.temperature = `${displayExtraInfo.temperature} ${temperatureUnit}`
      delete displayExtraInfo.temperature_unit
      delete displayExtraInfo.temperatureUnit
    }
    if (displayExtraInfo?.humidity) {
      const humidityUnit = displayExtraInfo?.humidity_unit ?? displayExtraInfo?.humidityUnit ?? ''
      displayExtraInfo.humidity = `${displayExtraInfo.humidity} ${humidityUnit}`
      delete displayExtraInfo.humidity_unit
      delete displayExtraInfo.humidityUnit
    }
    if (Array.isArray(displayExtraInfo?.sensorData)) {
      let temps = displayExtraInfo?.sensorData
      displayExtraInfo.temperatures = `${parseTemperature(temps)} °C`
      displayExtraInfo.doors = `${parseDoorData(temps)}`
    }
  }

  const [fakeState, setFakeState] = React.useState(0)
  const { t } = useTranslation()
  const { state } = useTimeZone()
  const map = useMap()
  let ref = React.useRef(null)
  React.useEffect(() => {
    if (selected && ref) {
      map.openPopup(ref.current as any)
      setFakeState(fakeState + 1)
    }
  }, [selected])
  if (selected){
    map.setView(latLng(latitude, longitude), 13)
    map.setView(latLng(latitude, longitude), 12)
  }
  return (
    <Marker
      position={latLng(latitude, longitude)}
      icon={
        new Icon({
          iconUrl: 'https://i.imgur.com/WK4MLHw.png',
          iconSize: [2.5, 5]
        })
      }
      eventHandlers={{
        click: () => setFakeState(fakeState + 1)
      }}
      // ref={el => openPopup(el)}
    >
      <Popup minWidth={149} ref={ref}>
        <h5>
          <strong>{t('Tracking Details')} :</strong>
        </h5>
        <strong>{t('Landmark')}</strong>: {landmark}
        <br />
        <strong>{t('Speed')}</strong>:{speedStr}
        <br />
        <strong>{t('Vehicle Status')}</strong>: {t(historyState)}
        <br />
        {Object.keys(displayExtraInfo).map((item: string) => {
          let isObj = typeof displayExtraInfo[item] === 'object'
          return (
            !isObj && (
              <Flex key={item}>
                <strong>{t(toTileCase(item))}</strong>:{' '}
                {t(displayExtraInfo[item])}
                <br />
              </Flex>
            )
          )
        })}
        <strong>{t('Time')}</strong>:
        {type === 'UTC'
          ? displayTime(gpsTimestamp)
          : hhmmADoMMMYYYY(istTimestamp)}
      </Popup>
    </Marker>
  )
}
